"use client"

import CloseIcon from "@mui/icons-material/Close"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import MenuIcon from "@mui/icons-material/Menu"
import PhoneIcon from "@mui/icons-material/Phone"
import { Box, Container, Drawer, List, ListItem, ListItemText, Menu, MenuItem, Fade } from "@mui/material"
import AppBar from "@mui/material/AppBar"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Toolbar from "@mui/material/Toolbar"
import { motion } from "framer-motion"
import {useState, useEffect} from "react"

const Navbar = () => {
  const [activeSection, setActiveSection] = useState("home")
  const [mobileOpen, setMobileOpen] = useState(false)
  const [aboutAnchor, setAboutAnchor] = useState(null)


  useEffect(() => {
    const handleScroll = () => handleSectionChange()
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

 const handleSectionChange = () => {
  const sections = [
    "home",
    "solution",
    "benefits",
    "our-technology",
    "provider-solutions",
    "payer-solutions",
    "ContactUs",
    "demo",
    "how-it-works",
    "our-benefits",
    "about",
    "our-mission",
    "our-vision",
    "our-feeds",
    "our-team",
    "our-experts",
    "our-presence",
    "gcc-presence",
    "our-values",
  ]

  let current = activeSection

  sections.forEach((section) => {
    const el = document.getElementById(section)
    if (!el) return

    const rect = el.getBoundingClientRect()

    // ✅ لا تغيّر إلا إذا كان السكشن في منتصف الشاشة فعلاً
    if (
      rect.top <= window.innerHeight * 0.45 &&
      rect.bottom >= window.innerHeight * 0.45
    ) {
      current = section
    }
  })

  setActiveSection(current)
}


  const scrollToSection = (id) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
      setActiveSection(id)
      setMobileOpen(false)
      setAboutAnchor(null)
    } else {
      console.warn(`Section with id "${id}" not found in the DOM`)
    }
  }

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "solution", label: "Solutions" },
    { id: "benefits", label: "Benefits" },
    { id: "gcc-presence", label: "Our Presence" },
  ]

  const aboutItems = [
    { id: "our-story", label: "Mission & Vision" },
     { id: "our-values", label: "Our Values" },
    { id: "our-experts", label: "Our Team" },
        { id: "our-feeds", label: "Our Feeds" },


  ]

  const handleAboutTextClick = () => scrollToSection("about")
  const handleAboutArrowClick = (event) => setAboutAnchor(event.currentTarget)
  const handleAboutClose = () => setAboutAnchor(null)
  const handleAboutSelect = (id) => {
    scrollToSection(id)
    handleAboutClose()
  }
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
    setAboutAnchor(null)
  }

  const drawer = (
    <Box
      sx={{
        width: 280,
        pt: 2,
        height: "100vh",
        background: `linear-gradient(135deg, #1f2937 0%, #374151 50%, #4b5563 100%)`,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, mb: 2 }}>
        <Box
          component="img"
          src="/WhatsApp_Image_2025-11-29_at_16.03.15_0d3bfb40-removebg-preview.png"
          alt="Kayan Healthcare Logo"
          sx={{
          width: "160px",        // ← كان 120px
    height: "70px",
            objectFit: "contain",
          }}
        />
        <IconButton onClick={handleDrawerToggle} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            sx={{
              cursor: "pointer",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              backgroundColor: activeSection === item.id && item.id !== "about" ? "rgba(255,255,255,0.15)" : "transparent",
              borderRadius: "8px",
              mx: 1,
              mb: 1,
            }}
          >
            <ListItemText
              primary={item.label}
              sx={{
                "& .MuiListItemText-primary": {
                  fontWeight: activeSection === item.id ? 600 : 400,
                  background:"transparent",
                  color: "#ffffff",
                  fontSize: "1rem",
                },
              }}
            />
            {item.id === "about" && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation()
                  setAboutAnchor(aboutAnchor ? null : e.currentTarget)
                }}
                sx={{ color: "#3b82f6" }}
              >
                <ExpandMoreIcon
                  sx={{
                    fontSize: "18px",
                    transform: aboutAnchor ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </IconButton>
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  )

  return (
    <>
      <AppBar
        position="fixed"
        component={motion.div}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        sx={{
          width: "auto",
          borderRadius: "0px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          top: "0px",
          left: "0px",
          right: "0px",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          zIndex: 1200,
          borderBottom: "1px solid rgba(255,255,255,0.05)",
          background: "rgba(255, 255, 255, 0.2)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            maxWidth:"full",
            mx: "auto",
            px: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Toolbar
            sx={{
              justifyContent: "space-between",
              backgroundColor: "transparent",
              py: 0.5,
              minHeight: { xs: "60px", md: "70px" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
             <Box
                component="img"
                src="/WhatsApp_Image_2025-11-29_at_16.03.15_0d3bfb40-removebg-preview.png"
                alt="Kayan Healthcare Logo"
                sx={{
                  width: { xs: "140px", sm: "160px", md: "180px", lg: "200px" },
                  height: { xs: "40px", sm: "50px", md: "60px", lg: "70px" },
                  objectFit: "contain",
                  cursor: "pointer",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "scale(1.05)" },
                  display: "block",
                }}
                onClick={() => scrollToSection("home")}
              />
              <Box sx={{ display: { xs: "none", sm: "block" }, ml: 0.5 }}>
                <span
                  style={{
                    color: "#ffffff",
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    fontSize: "1.1rem",
                    fontFamily: "Poppins",
                    verticalAlign: "middle",
                  }}
                >
                  Kayan Healthcare Technologies
                </span>
              </Box>
            </Box>

            {/* Nav Items */}
            <Box
              sx={{
                display: { xs: "none", lg: "flex" },
                alignItems: "center",
                gap: { md: 1.25, lg: 2 },
                pr: 1,
                ml: { md: 2, lg: 3 },
                flexWrap: "wrap",
                justifyContent: { md: "flex-end" },
              }}
            >
              {navItems.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 0.4,
                    color: "#ffffff",
                    fontSize: { md: "13px", lg: "14px" },
                    fontWeight: "bold",
                    cursor: "pointer",
                    padding: { md: "8px 12px", lg: "10px 16px" },
                    borderRadius: { md: "10px", lg: "12px" },
                    transition: "all 0.3s ease",
                    fontFamily: "Inter, sans-serif",
                    position: "relative",
                    "&:hover": {
                      color: "#ffffff",
                      backgroundColor: "rgba(255,255,255,0.1)",
                      transform: "translateY(-1px)",
                      textShadow: "0 0 8px rgba(255,255,255,0.6)",
                    },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "6px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: activeSection === item.id && item.id !== "about" ? "50%" : "0%",
                      height: "2px",
                      backgroundColor: "#ffffff",
                      transition: "all 0.3s ease",
                      borderRadius: "1px",
                    },
                    "&:hover::after": {
                      width: "50%",
                    },
                  }}
                >
                  <Box
                    onClick={() =>
                      item.id === "about" ? handleAboutTextClick() : scrollToSection(item.id)
                    }
                    sx={{ padding: "0 3px" }}
                  >
                    {item.label}
                  </Box>
                  {item.id === "about" && (
                    <IconButton
                      onClick={handleAboutArrowClick}
                      sx={{ padding: 0, color: "#ffffff" }}
                    >
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "18px",
                          transform: aboutAnchor ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </IconButton>
                  )}
                </Box>
              ))}

              <Button
                variant="contained"
                startIcon={<PhoneIcon />}
                sx={{
                  display: { xs: "none", lg: "inline-flex" },
                  ml: 1,
                  background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                  color: "#fff",
                  fontWeight: 600,
                  borderRadius: "25px",
                  px: { md: 2.5, lg: 3 },
                  py: { md: 1, lg: 1.2 },
                  boxShadow: "0 4px 20px rgba(59, 130, 246, 0.3)",
                  fontFamily: "Inter, sans-serif",
                  "&:hover": {
                    background: "linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 30px rgba(59, 130, 246, 0.4)",
                  },
                  transition: "all 0.3s ease",
                }}
                onClick={() => scrollToSection("contact")}
              >
                Contact Us
              </Button>
            </Box>

            {/* Mobile menu */}
            <Box sx={{ display: { xs: "flex", lg: "none" } }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{
                  color: "#111827",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  borderRadius: "12px",
                  padding: "12px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    transform: "scale(1.04)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* About dropdown menu */}
      <Menu
        anchorEl={aboutAnchor}
        open={Boolean(aboutAnchor)}
        onClose={handleAboutClose}
        TransitionComponent={Fade}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
            border: "1px solid rgba(0,0,0,0.05)",
            mt: 1,
            minWidth: "220px",
            background: "rgba(255, 255, 255, 0.98)",
            backdropFilter: "blur(20px)",
          },
        }}
      >
        {aboutItems.map((item) => (
          <MenuItem
            key={item.id}
            style={{
              background:"#fff",

            }}
            onClick={() => handleAboutSelect(item.id)}
            sx={{
              py: 1.5,
              px: 3,
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              color: "#041E2F",
              "&:hover": {
                color: "#1d4ed8",
              },
              transition: "all 0.2s ease",
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 280,
            background: "transparent",
            border: "none",
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  )
}

export default Navbar